gsap.registerPlugin(ScrollTrigger);
ScrollTrigger.config({autoRefreshEvents: "visibilitychange,DOMContentLoaded,load"});
let mm = gsap.matchMedia();

const bgImagesDesktop = [
  "url('https://cdn.shopify.com/s/files/1/0156/3905/2336/files/zero_bg.jpg?v=1749450050')",
  "url('https://cdn.shopify.com/s/files/1/0156/3905/2336/files/bg_pro.jpg?v=1749512817')",
  "url('https://cdn.shopify.com/s/files/1/0156/3905/2336/files/bg_collagen.jpg?v=1749512818')",
  "url('https://cdn.shopify.com/s/files/1/0156/3905/2336/files/pdrn_bg.jpg?v=1749514061')"
];

const bgImagesMobile = [
  "url('https://cdn.shopify.com/s/files/1/0156/3905/2336/files/zero_bg_m.png?v=1750138830')",
  "url('https://cdn.shopify.com/s/files/1/0156/3905/2336/files/pro_bg_m_81398652-dc07-4ca6-b2b9-cc14c0b8229f.png?v=1750138830')",
  "url('https://cdn.shopify.com/s/files/1/0156/3905/2336/files/collagen_bg_m.png?v=1750138830')",
  "url('https://cdn.shopify.com/s/files/1/0156/3905/2336/files/pdrn_bg_m.png?v=1750138830')"
];

let currentIndex = 0;
let bgImages;
const $section = $(".section05 .prd_bg");
const $items = $(".prd_item");
const $triggers = $(".trigger_item");

// 배경 및 active 클래스 적용 함수
function setActive(index) {
  currentIndex = index;
  $section.css({
    "background-image": bgImages[index],
    "background-size": "cover",
    "background-position": "center"
  });
  $items.removeClass("active").eq(index).addClass("active");
    if (index === 1) {
    $(".section05").addClass("dimmed2");
  } else {
    $(".section05").removeClass("dimmed2");
  }
}

// .section05 ScrollTrigger 초기화
function initScrollTrigger() {


  const isMobile = window.innerWidth <= 768;
  bgImages = isMobile ? bgImagesMobile : bgImagesDesktop;



  $triggers.each(function(index, el){
    ScrollTrigger.create({
      trigger: el,
      start: "top center",
      end: "bottom center",
      onEnter: () => setActive(index),
      onEnterBack: () => setActive(index),
    });
  });

  ScrollTrigger.create({
    trigger: ".prd_trigger_wrap",
    start: "top top",
    end: "bottom bottom",
    invalidateOnRefresh: true, 
  
  });

  updateActiveByScroll();

  ScrollTrigger.refresh();
}

function bindPrdItemEvents() {
  const isMobile = window.innerWidth <= 768;
  $items.off("mouseenter click");

  if (isMobile) {
    $items.on("click", function () {
      const index = $(this).index();
      setActive(index);
    });
  } else {
    $items.on("mouseenter", function () {
      const index = $(this).index();
      setActive(index);
    });
  }
}


// 현재 스크롤 위치 기반 active 클래스 업데이트
function updateActiveByScroll() {
  let foundIndex = 0;
  $triggers.each(function(index, el) {
    const rect = el.getBoundingClientRect();
    if (rect.top <= window.innerHeight / 2 && rect.bottom >= window.innerHeight / 2) {
      foundIndex = index;
      return false;
    }
  });

  console.log("🎯 updateActiveByScroll 실행됨 → index:", foundIndex);
  setActive(foundIndex);
}

// 데스크탑 전용 애니메이션 설정
function setupDesktopAnimations() {
  gsap.to(".section04 .bg_box", {
    scrollTrigger: {
      trigger: ".section04",
      pin: ".section04 .bg_box",
      start: "top 0%",
      end: "bottom 40%",
      scrub: 1,
    }
  });

  gsap.to(".section04 .txt_show", {
    scrollTrigger: {
      trigger: ".section04",
      start: "top 40%",
      toggleClass: { targets: ".section04 .txt_show", className: "show" },
    },
  });

  gsap.set(".left_txt", { opacity: 0, x: -250 });
  gsap.set(".prd_wrap", { opacity: 0, x: 250 });

  gsap.to(".left_txt", {
    scrollTrigger: {
      trigger: ".section05",
      start: "top 20%",
      end: "top 0",
      scrub: true,
      invalidateOnRefresh: true,
    },
    opacity: 1,
    x: 0,
    duration: 1
  });

  gsap.to(".prd_wrap", {
    scrollTrigger: {
      trigger: ".section05",
      start: "top 20%",
      end: "top 0",
      scrub: true,
      invalidateOnRefresh: true,
    },
    opacity: 1,
    x: 0,
    duration: 1
  });

  gsap.to(".section05", {
    scrollTrigger: {
      trigger: ".section05",
      start: "top 65%",
      once: true,
      onEnter: () => {
        document.querySelector(".section05").classList.add("dimmed");
        
      },
    },
  });

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: ".section06 .move_wrap",
      start: "top 100%",
 end: "bottom 120%", 
      scrub: true, 
      
    }
  });

  tl.fromTo(".section06 .left_txt", 
    { x: "-100vw", opacity: 0 }, 
    { x: "0", opacity: 1, duration: 1 }
  ).fromTo(".section06 .right_txt", 
    { x: "100vw", opacity: 0 }, 
    { x: "0", opacity: 1, duration: 1 },
    "<" // 동시에 시작
  );

  
  // 초기 width 설정
gsap.set(".full_video", {
  width: "60%",
  transformOrigin: "center center"
});

// 1. 비디오 width 점점 커지기 (스크롤 300px 구간)
gsap.to(".full_video", {
  scrollTrigger: {
    trigger: ".full_video_wrap",
    start: "top top",
    end: "+=300",
    scrub: true,
      onUpdate: (self) => {
      if (self.progress === 1) {
        document.querySelector(".video_wrap video").classList.add("active");
      } else {
        document.querySelector(".video_wrap video").classList.remove("active");
      }
    },
  },

  width: "100%",
  ease: "none",
});

// 2. 고정(pin) 유지 (스크롤 900px 구간)
ScrollTrigger.create({
  trigger: ".full_video_wrap",
  start: "top top",
  end: "+=900",
  pin: true,
  pinSpacing: true,
});

// 3. 딤 오버레이 자연스레 등장 (비디오 100% 되는 구간과 동일하게 시작)
gsap.to(".dim_overlay", {
  scrollTrigger: {
    trigger: ".full_video_wrap",
    start: "top top",      // 100% 되자마자 시작
    end: "top+=300 top",   // 비디오 width 커지는 구간과 동일 길이
    scrub: true,
  },
  opacity: 1,
  ease: "none",
});

// 4. 텍스트 천천히 올라오며 등장 (딤과 같은 타이밍)
gsap.fromTo(".video_txt",
  { opacity: 0, y: 50 },
  {
    scrollTrigger: {
      trigger: ".full_video_wrap",
      start: "top top",       // 100% 되자마자 시작
      end: "top+=300 top",
      scrub: true,
      
    },
    opacity: 1,
    y: 0,
    ease: "power2.out",
  }
);



ScrollTrigger.create({
  trigger: ".section07",
  start: "top top",       
  endTrigger:".tech_line",
  end: "bottom 40%",         
  pin: ".fixed_txt",
  pinSpacing: true,
  
});
  
  gsap.to(".tech_gif .tech_bg1", {
  scrollTrigger: {
    trigger: ".section07",         // 기준 스크롤 트리거
    start: "top-=120 top",      // 요소가 화면 아래쪽에 닿을 때 시작
 end: "bottom 5%",           // fixed_wrap의 bottom이 viewport center 지점에 도달할 때 끝
    scrub: true,                    // 스크롤에 따라 부드럽게 연동
  },
  scale: 0.7,                       // 크기 줄이기
  opacity: 0,       
      // 서서히 투명하게
  ease: "none"  

});
gsap.to(".tech_gif .tech_bg2", {
  scrollTrigger: {
    trigger: ".tech_gif .tech_bg2", // tech_bg2 자체가 트리거
   start: "top-=120 top" ,             // tech_bg2의 top이 뷰포트 80% 지점에 닿을 때 시작
    end: "bottom 5%",              // 끝나는 지점 (원하는 만큼 조절)
    scrub: true,
                 // 개발 시 트리거 위치 확인용
  },
  scale: 0.7,
  opacity: 0,
  ease: "none"
});


  gsap.to(".delay1", {
    scrollTrigger: {
      trigger: ".section08",
      start: "bottom 130%",
  //     end: "top 0",
      toggleClass: { targets: ".section08 .delay1", className: "show" },
    },
  });
  gsap.to(".delay2", {
    scrollTrigger: {
      trigger: ".section08",
      start: "bottom 130%",
  //     end: "top 0",
      toggleClass: { targets: ".section08 .delay2", className: "show" },
    },
  });
  

}

// 모바일 전용 애니메이션 설정
function setupMobileAnimations() {
  gsap.to(".section04 .bg_box", {
    scrollTrigger: {
      trigger: ".section04",
      pin: ".section04 .bg_box",
      pinSpacing: true,
      pinType: "fixed",
       anticipatePin: 1,
      start: "top 0%",
      end: "bottom 30%",
      scrub: 1,

    },
  });

  gsap.to(".section04 .txt_show", {
    scrollTrigger: {
      trigger: ".section04",
      start: "top 40%",
      toggleClass: { targets: ".section04 .txt_show", className: "show" },
    },
  });

  gsap.to(".section05", {
    scrollTrigger: {
      trigger: ".section05",
      start: "top 65%",
      once: true,
      onEnter: () => {
        document.querySelector(".section05").classList.add("dimmed");
      },
    },
  });

  gsap.to(".section05 .txt_none", {
    scrollTrigger: {
      trigger: ".section05",
      start: "top top+=60",
      onEnter: () => {
        document.querySelectorAll(".section05 .txt_none").forEach(el => el.classList.add("show"));
      },
    },
  });

  gsap.to(".section06 .bg_pin_wrap", {
    scrollTrigger: {
      trigger: ".section06",
      pin: ".section06 .bg_pin_wrap",
      pinSpacing: true,
      pinType: "fixed",
       anticipatePin: 1,
      start: "top 0%",
      end: "bottom 30%",
      scrub: 1,
      
    },
  });

  gsap.to(".section06 .txt_none", {
    scrollTrigger: {
      trigger: ".section06",
      start: "top 50%",
      toggleClass: { targets: ".section06 .txt_none", className: "show" },
    },
  });

  gsap.to(".tech_gif .tech_bg1", {
  scrollTrigger: {
    trigger: ".tech_gif",         // 기준 스크롤 트리거
    start: "top 20%",       // 요소가 화면 아래쪽에 닿을 때 시작
 end: "bottom 5%",           // fixed_wrap의 bottom이 viewport center 지점에 도달할 때 끝
    scrub: true,                    // 스크롤에 따라 부드럽게 연동
  },
  scale: 0.7,                       // 크기 줄이기
  opacity: 0,                       // 서서히 투명하게
  ease: "none"  

});
gsap.to(".tech_gif .tech_bg2", {
  scrollTrigger: {
    trigger: ".tech_gif .tech_bg2", // tech_bg2 자체가 트리거
    start: "top 20%",               // tech_bg2의 top이 뷰포트 80% 지점에 닿을 때 시작
    end: "bottom 5%",              // 끝나는 지점 (원하는 만큼 조절)
    scrub: true,
    // markers: true,               // 개발 시 트리거 위치 확인용
  },
  scale: 0.7,
  opacity: 0,
  ease: "none"
});
  var marquee = new Swiper('.marquee-slide', {
    slidesPerView: 1,
    loop: true,
    speed: 5000,
    autoplay:{
        delay : 0,
        disableOnInteraction : false,
    },
    breakpoints: {
        769: {
            slidesPerView: 3.5
        },
        1024: {
            slidesPerView: 4.5
        },
        1400: {
            slidesPerView: 5.8
        }
    }
        
        
    });
}

// 미디어 쿼리별 애니메이션 재등록 함수
function registerAnimations() {
  mm.revert();

  mm.add("(min-width: 1025px)", () => {
    setupDesktopAnimations();
  });

  mm.add("(max-width: 1024px)", () => {
    setupMobileAnimations();
  });
}


function initialize() {
  initScrollTrigger();
  registerAnimations();
  bindPrdItemEvents();
  updateActiveByScroll();
}

// 초기 실행
initialize();

window.addEventListener("resize", () => {
  bindPrdItemEvents(); 
});



